var map = {
	"./battleship.png": 71,
	"./calculator.png": 140,
	"./cv-project.png": 888,
	"./etch-a-sketch.png": 421,
	"./library.png": 671,
	"./memory-game.png": 819,
	"./photo-tagging.png": 483,
	"./restaurant-page.png": 134,
	"./shopping-cart.png": 42,
	"./tic-tac-toe.png": 929,
	"./todo-list.png": 574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;